import { Injectable } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { IAppError, ICommunication, InfoCommunication, ISimplifiedCommunication, Reference } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { CommunicationsApiService } from "./api/communications-api.service";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class CommunicationsService {
  constructor(private communicationsApiService: CommunicationsApiService, private userService: UserService) {}

  public list(serviceId: string, startDate?: string, endDate?: string, services?: string[]): Observable<InfoCommunication[]> {
    const routeName = this.communicationsApiService.readRoutes[0];
    const isAuth = this.userService.isAuthorizedSync(null, routeName, "GET");
    if (!isAuth) {
      FileLogger.warn("CommunicationsService", "User does not have access to: GET " + routeName);
      return of([]) as Observable<InfoCommunication[]>;
    }
    return this.communicationsApiService.listActive(serviceId, services, startDate, endDate);
  }

  public listForPatient(patientId: string, startDate?: string, endDate?: string): Observable<InfoCommunication[]> {
    const routeName = this.communicationsApiService.readRoutes[0];
    const isAuth = this.userService.isAuthorizedSync(null, routeName, "GET");
    if (!isAuth) {
      FileLogger.warn("CommunicationsService", "User does not have access to: GET " + routeName);
      return of([]) as Observable<InfoCommunication[]>;
    }
    return this.communicationsApiService.listActiveForPatient(patientId, startDate, endDate);
  }

  public listAllForGroup(groupId: string): Observable<InfoCommunication[]> {
    const routeName = this.communicationsApiService.readRoutes[0];
    const isAuth = this.userService.isAuthorizedSync(null, routeName, "GET");
    if (!isAuth) {
      FileLogger.warn("CommunicationsService", "User does not have access to: GET " + routeName);
      return of([]) as Observable<InfoCommunication[]>;
    }
    return this.communicationsApiService.listAllForGroup(groupId);
  }

  public listOne(communicationId: string, patientId: string): Observable<ICommunication> {
    return this.communicationsApiService.listOne(communicationId, patientId);
  }

  public create(communication: ISimplifiedCommunication): Observable<ICommunication> {
    return this.communicationsApiService.create(communication);
  }

  public update(communication: ICommunication, patientsIds: Reference[]): Observable<number> {
    return this.communicationsApiService.update(communication, patientsIds);
  }

  public delete(communicationId: string, patientId: string, patientsIds: Reference[]): Observable<boolean> {
    return this.communicationsApiService.delete(communicationId, patientId, patientsIds);
  }

  public async exportCommunications(patientId: string, lang: string): Promise<void> {
    this.communicationsApiService.exportCommunications(patientId, lang).subscribe(
      (blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url);
      },
      (error: IAppError) => {
        FileLogger.error("CommunicationsService", "exportCommunications", error);
        throw new Error(error.message);
      }
    );
  }
}
